import {HttpHeaders} from '@angular/common/http';
import {
  AddAbsenceWhitelistEntryResponse,
  AddWhitelistEntryResponse,
  BlacklistEntry,
  Configuration,
  ConfigurationServiceInterface,
  DeleteWhitelistEntryResponse,
  DisplayNumber,
  GetAbsenceActivatedForMobile,
  GetAbsenceSubscriptionResponse,
  GetAbsenceWhitelistResponse,
  GetAcdGroupNumberNumberResponse,
  GetActiveProfileLeisureResponse,
  GetActiveProfileResponse,
  GetBlacklistResponse,
  GetBlockedStatusResponse,
  GetCallbackEnabledResponse,
  GetColleagueNumberResponse,
  GetCompanyDisplayNumberFollowsLoginResponse,
  GetCompanyDisplayNumberFollowsTimeRoutingResponse,
  GetCompanyDisplayNumberInternalResponse,
  GetCompanyDisplayNumberResponse,
  GetDisplayNumberAfterWorkHoursResponse,
  GetDisplayNumberResponse,
  GetEndUserProfilesResponse,
  GetForwardingNumberResponse,
  GetLoginFollowsTimeRoutingResponse,
  GetModesResponse,
  GetNoReplyTimeResponse,
  GetPreferredLanguageResponse,
  GetShowShortNumberResponse,
  GetSwitchboardNumberResponse,
  GetTimeRoutingActivatedForMobileResponse,
  GetTimeRoutingEnabledResponse,
  GetTimeRoutingResponse,
  GetWhitelistResponse,
  Mode,
  NumberListEntry,
  RemoveAbsenceWhitelistEntryResponse,
  Response,
  SetAbsenceActivatedForMobile,
  SetAbsenceSubscriptionResponse,
  SetAcdGroupNumberNumberResponse,
  SetActiveProfileLeisureResponse,
  SetActiveProfileResponse,
  SetBlockedStatusResponse,
  SetCallbackEnabledResponse,
  SetColleagueNumberResponse,
  SetCompanyDisplayNumberFollowsLoginResponse,
  SetCompanyDisplayNumberFollowsTimeRoutingResponse,
  SetCompanyDisplayNumberInternalResponse,
  SetCompanyDisplayNumberResponse,
  SetDisplayNumberAfterWorkHoursResponse,
  SetDisplayNumberResponse,
  SetForwardingNumberResponse,
  SetLoginFollowsTimeRoutingResponse,
  SetModeResponse,
  SetNoReplyTimeResponse,
  SetSwitchboardNumberResponse,
  SetTimeRoutingActivatedForMobileResponse,
  SetTimeRoutingEnabledResponse,
  SetTimeRoutingResponse,
  SetWhitelistResponse,
  TimeRouting,
  WhitelistEntry
} from '@gt-api';
import {Observable, of} from 'rxjs';

export class ConfigurationServiceStub implements ConfigurationServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  getMode1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<GetModesResponse> {
    return of({code: 200});
  }

  addAbsenceWhitelistEntry1(organization?: string, login?: string, body?: NumberListEntry): Observable<AddAbsenceWhitelistEntryResponse> {
    return of({code: 200});
  }

  addBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry): Observable<Response> {
    return of({code: 200});
  }

  addCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, body?: BlacklistEntry): Observable<Response> {
    return of({code: 200});
  }

  addCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, body?: WhitelistEntry): Observable<Response> {
    return of({code: 200});
  }

  addWhitelistEntry1(
    incoming: boolean,
    organization?: string,
    login?: string,
    body?: WhitelistEntry
  ): Observable<AddWhitelistEntryResponse> {
    return of({code: 200});
  }

  addWhitelistIncomingEntry1(organization?: string, login?: string, body?: WhitelistEntry): Observable<AddWhitelistEntryResponse> {
    return of({code: 200});
  }

  deleteBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number): Observable<Response> {
    return of({code: 200});
  }

  deleteCompanyBlacklistEntry1(incoming: boolean, organization?: string, login?: string, index?: number): Observable<Response> {
    return of({code: 200});
  }

  deleteCompanyWhitelistEntry1(incoming: boolean, organization?: string, login?: string, index?: number): Observable<Response> {
    return of({code: 200});
  }

  deleteWhitelistEntry1(
    incoming: boolean,
    organization?: string,
    login?: string,
    index?: number
  ): Observable<DeleteWhitelistEntryResponse> {
    return of({code: 200});
  }

  deleteWhitelistIncomingEntry1(organization?: string, login?: string, index?: number): Observable<DeleteWhitelistEntryResponse> {
    return of({code: 200});
  }

  getAbsenceActivatedForMobile1(organization?: string, login?: string): Observable<GetAbsenceActivatedForMobile> {
    return of({code: 200});
  }

  getAbsenceSubscription1(organization?: string, login?: string): Observable<GetAbsenceSubscriptionResponse> {
    return of({code: 200});
  }

  getAbsenceWhitelist1(organization?: string, login?: string): Observable<GetAbsenceWhitelistResponse> {
    return of({code: 200});
  }

  getAcdGroupNumberNumber1(organization?: string, login?: string): Observable<GetAcdGroupNumberNumberResponse> {
    return of({code: 200});
  }

  getActiveProfile1(organization?: string, login?: string): Observable<GetActiveProfileResponse> {
    return of({code: 200});
  }

  getActiveProfileLeisure1(organization?: string, login?: string): Observable<GetActiveProfileLeisureResponse> {
    return of({code: 200});
  }

  getBlacklist1(incoming: boolean, organization?: string, login?: string): Observable<GetBlacklistResponse> {
    return of({code: 200});
  }

  getBlockedStatus1(organization?: string, login?: string): Observable<GetBlockedStatusResponse> {
    return of({code: 200});
  }

  getCallbackEnabled1(organization?: string, login?: string): Observable<GetCallbackEnabledResponse> {
    return of({code: 200});
  }

  getColleagueNumber1(organization?: string, login?: string): Observable<GetColleagueNumberResponse> {
    return of({code: 200});
  }

  getCompanyBlacklist1(incoming: boolean, organization?: string, login?: string): Observable<GetBlacklistResponse> {
    return of({code: 200});
  }

  getCompanyDisplayNumber1(organization?: string, login?: string): Observable<GetCompanyDisplayNumberResponse> {
    return of({code: 200});
  }

  getCompanyDisplayNumberFollowsLogin1(organization?: string, login?: string): Observable<GetCompanyDisplayNumberFollowsLoginResponse> {
    return of({code: 200});
  }

  getCompanyDisplayNumberFollowsTimeRouting1(
    organization?: string,
    login?: string
  ): Observable<GetCompanyDisplayNumberFollowsTimeRoutingResponse> {
    return of({code: 200});
  }

  getCompanyDisplayNumberInternal1(organization?: string, login?: string): Observable<GetCompanyDisplayNumberInternalResponse> {
    return of({code: 200});
  }

  getCompanySwitchboardNumber1(departmentId: number, organization?: string, login?: string): Observable<GetSwitchboardNumberResponse> {
    return of({code: 200});
  }

  getCompanyWhitelist1(incoming: boolean, organization?: string, login?: string): Observable<GetWhitelistResponse> {
    return of({code: 200});
  }

  getDisplayNumber1(organization?: string, login?: string): Observable<GetDisplayNumberResponse> {
    return of({code: 200, displayNumber: {displayNumber: '11234123'}});
  }

  getDisplayNumberAfterWorkHours1(organization?: string, login?: string): Observable<GetDisplayNumberAfterWorkHoursResponse> {
    return of({code: 200});
  }

  getEndUserProfiles1(organization?: string): Observable<GetEndUserProfilesResponse> {
    return of({code: 200});
  }

  getForwardingNumber1(organization?: string, login?: string): Observable<GetForwardingNumberResponse> {
    return of({code: 200});
  }

  getLoginFollowsTimeRouting1(organization?: string, login?: string): Observable<GetLoginFollowsTimeRoutingResponse> {
    return of({code: 200});
  }

  getModes1(organization?: string, login?: string): Observable<GetModesResponse> {
    return of({code: 200});
  }

  getNoReplyTime1(organization?: string, login?: string): Observable<GetNoReplyTimeResponse> {
    return of({code: 200});
  }

  getPreferredLanguage1(organization?: string, login?: string): Observable<GetPreferredLanguageResponse> {
    return of({code: 200});
  }

  getShowShortNumber1(organization?: string, login?: string): Observable<GetShowShortNumberResponse> {
    return of({code: 200});
  }

  getSwitchboardNumber1(organization?: string, login?: string): Observable<GetSwitchboardNumberResponse> {
    return of({code: 200});
  }

  getTimeRouting1(organization?: string, login?: string): Observable<GetTimeRoutingResponse> {
    return of({code: 200});
  }

  getTimeRoutingActivatedForMobile1(organization?: string, login?: string): Observable<GetTimeRoutingActivatedForMobileResponse> {
    return of({code: 200});
  }

  getTimeRoutingEnabled1(organization?: string, login?: string): Observable<GetTimeRoutingEnabledResponse> {
    return of({code: 200});
  }

  getWhitelist1(incoming: boolean, organization?: string, login?: string): Observable<GetWhitelistResponse> {
    return of({code: 200});
  }

  getWhitelistIncoming1(organization?: string, login?: string): Observable<GetWhitelistResponse> {
    return of({code: 200});
  }

  removeAbsenceWhitelistEntry1(
    organization?: string,
    login?: string,
    body?: NumberListEntry
  ): Observable<RemoveAbsenceWhitelistEntryResponse> {
    return of({code: 200});
  }

  removeAbsenceWhitelistEntryWithId1(id: number, organization?: string, login?: string): Observable<RemoveAbsenceWhitelistEntryResponse> {
    return of({code: 200});
  }

  setAbsenceActivatedForMobile1(enabled: boolean, organization?: string, login?: string): Observable<SetAbsenceActivatedForMobile> {
    return of({code: 200});
  }

  setAbsenceSubscription1(organization?: string, login?: string, body?: boolean): Observable<SetAbsenceSubscriptionResponse> {
    return of({code: 200});
  }

  setAcdGroupNumberNumber1(acdGroupNumber: string, organization?: string, login?: string): Observable<SetAcdGroupNumberNumberResponse> {
    return of({code: 200});
  }

  setActiveProfile1(profile: number, organization?: string, login?: string): Observable<SetActiveProfileResponse> {
    return of({code: 200});
  }

  setActiveProfileLeisure1(profile: number, organization?: string, login?: string): Observable<SetActiveProfileLeisureResponse> {
    return of({code: 200});
  }

  setBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>): Observable<Response> {
    return of({code: 200});
  }

  setBlockedStatus1(organization?: string, login?: string, body?: string): Observable<SetBlockedStatusResponse> {
    return of({code: 200});
  }

  setCallbackEnabled1(enabled: boolean, organization?: string, login?: string): Observable<SetCallbackEnabledResponse> {
    return of({code: 200});
  }

  setColleagueNumber1(colleagueNumber: string, organization?: string, login?: string): Observable<SetColleagueNumberResponse> {
    return of({code: 200});
  }

  setCompanyBlacklist1(incoming: boolean, organization?: string, login?: string, body?: Array<BlacklistEntry>): Observable<Response> {
    return of({code: 200});
  }

  setCompanyDisplayNumber1(
    companyDisplayNumber: string,
    shown: boolean,
    auto: boolean,
    organization?: string,
    login?: string
  ): Observable<SetCompanyDisplayNumberResponse> {
    return of({code: 200});
  }

  setCompanyDisplayNumberFollowsLogin1(
    enabled: boolean,
    organization?: string,
    login?: string
  ): Observable<SetCompanyDisplayNumberFollowsLoginResponse> {
    return of({code: 200});
  }

  setCompanyDisplayNumberFollowsTimeRouting1(
    enabled: boolean,
    organization?: string,
    login?: string
  ): Observable<SetCompanyDisplayNumberFollowsTimeRoutingResponse> {
    return of({code: 200});
  }

  setCompanyDisplayNumberInternal1(
    enabled: boolean,
    organization?: string,
    login?: string
  ): Observable<SetCompanyDisplayNumberInternalResponse> {
    return of({code: 200});
  }

  setCompanySwitchboardNumber1(
    departmentId: number,
    switchboardNumber: string,
    organization?: string,
    login?: string
  ): Observable<SetSwitchboardNumberResponse> {
    return of({code: 200});
  }

  setCompanyWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>): Observable<Response> {
    return of({code: 200});
  }

  setDisplayNumber1(organization?: string, login?: string, body?: DisplayNumber): Observable<SetDisplayNumberResponse> {
    return of({code: 200});
  }

  setDisplayNumberAfterWorkHours1(
    organization?: string,
    login?: string,
    body?: DisplayNumber
  ): Observable<SetDisplayNumberAfterWorkHoursResponse> {
    return of({code: 200});
  }

  setForwardingNumber1(forwardingNumber: string, organization?: string, login?: string): Observable<SetForwardingNumberResponse> {
    return of({code: 200});
  }

  setLoginFollowsTimeRouting1(enabled: boolean, organization?: string, login?: string): Observable<SetLoginFollowsTimeRoutingResponse> {
    return of({code: 200});
  }

  setMode1(organization?: string, login?: string, body?: Mode): Observable<SetModeResponse> {
    return of({code: 200});
  }

  setNoReplyTime1(noReplyTime: number, organization?: string, login?: string): Observable<SetNoReplyTimeResponse> {
    return of({code: 200});
  }

  setPreferredLanguage1(organization?: string, login?: string, body?: string): Observable<Response> {
    return of({code: 200});
  }

  setShowShortNumber1(showShortNumber: boolean, organization?: string, login?: string): Observable<Response> {
    return of({code: 200});
  }

  setSwitchboardNumber1(switchboardNumber: string, organization?: string, login?: string): Observable<SetSwitchboardNumberResponse> {
    return of({code: 200});
  }

  setTimeRouting1(organization?: string, login?: string, body?: TimeRouting): Observable<SetTimeRoutingResponse> {
    return of({code: 200});
  }

  setTimeRoutingActivatedForMobile1(
    enabled: boolean,
    organization?: string,
    login?: string
  ): Observable<SetTimeRoutingActivatedForMobileResponse> {
    return of({code: 200});
  }

  setTimeRoutingEnabled1(enabled: boolean, organization?: string, login?: string): Observable<SetTimeRoutingEnabledResponse> {
    return of({code: 200});
  }

  setWhitelist1(incoming: boolean, organization?: string, login?: string, body?: Array<WhitelistEntry>): Observable<SetWhitelistResponse> {
    return of({code: 200});
  }

  setWhitelistIncoming1(organization?: string, login?: string, body?: Array<WhitelistEntry>): Observable<SetWhitelistResponse> {
    return of({code: 200});
  }
}
